import Send from '../utils/Send.js';

export default {
	get(param) {
		return Send({
			url: '/order',
			method: 'get',
			params: param,
		});
	},

	getAll(param) {
		return Send({
			url: '/orderAll',
			method: 'get',
			params: param,
		});
	},

	getSms(param) {
		return Send({
			url: '/selectReceipt',
			method: 'get',
			params: param,
		});
	},
	//영수증 데이터 조회
	getReSms(param) {
		return Send({
			url: '/selectRetailReceipt',
			method: 'get',
			params: param,
		});
	},
	//영수증 데이터 조회
	getCrSms(param) {
		return Send({
			url: '/selectCreditReceipt',
			method: 'get',
			params: param,
		});
	},
	//report 탭 주문 데이터 조회
	getReportData(param){
		return Send({
			url: '/selectReportData',
			method: 'get',
			params: param,
		});
	},
	sendSms(param) {
		return Send({
			url: '/sendReceipt',
			method: 'get',
			params: param,
		});
	},

	sendRetailSms(param) {
		return Send({
			url: '/sendEreceiptRetail',
			method: 'post',
			data: param,
		});
	},

	sendCreditSms(param) {
		return Send({
			url: '/sendEreceiptCredit',
			method: 'post',
			data: param,
		});
	},

	sendEmail(param) {
		return Send({
			url: '/sendEreceiptRetailEmail',
			method: 'post',
			data: param,
		});
	},

	closeDaily(param) {
		return Send({
			url: '/closeDaily',
			method: 'post',
			data: param,
		});
	},
	
	getUrl(sUrl) {
		return Send({
			url: '/getUrl',
			method: 'get',
			params: {
				sUrl: sUrl,
			},
		});
	},
	getExchgSms(param) {
		return Send({
			url: '/exchangeReceipt',
			method: 'get',
			params: param,
		});
	},
  getCode(codeId, code) {
    return Send({
      url: '/code/' + code,
      method: 'get',
      params: {
        codeId: codeId
      }
    })
  }
};
